import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';

import { isEmpty, isNull, isUndefined, } from 'lodash';
import Swal from 'sweetalert2';

import axios from 'axios';
import $ from 'jquery';

import useAuth from '../../controllers/users/useAuth';

import {
    checkIfUserIsMaster, dataTableLanguaje, responseGet, globalSettings, styles, numberSet, separatorsNumbersSet, setBadgeStatusGeneric, sendMessageCloseCurrentWindowAsync, processEvaluateGet,
    languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import { supplierModelGet, } from '../../models/expenses/suppliers';
import SupplierAddEditDetails from './SupplierAddEditDetails';
import Menu from '../main/Menu';
import { supplierProcessButtonsGetAsync } from '../../controllers/suppliers/suppliers';
import BuildingHeader from '../buildings/BuildingHeader';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { validationCountryGetAsync } from '../../helpers/validations';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { countryModelGet } from '../../models/countries/country';

const currentMethod = 'Suppliers';

export default function Suppliers({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region others
    let result;
    let dataObj = {};
    let headerObj = {};
    let swalProperties = {};
    const auth = useAuth();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [showModal, setShowModal] = useState(false);
    const [processType, setProcessType] = useState(0);
    const [showLoading, setShowLoading] = useState({ buildings: true, suppliers: true, });
    // const [processValues, setProcessValues] = useState({
    //     e: {},
    //     id: '',
    //     description: '',
    //     dtId: 'dtSuppliers',
    //     dtRowIndex: 0,
    // });
    //#endregion others

    //#region suppliers
    const dtSuppliersId = 'dtSuppliers';
    //const btnSupplierBalanceId = 'btnSupplierBalance';
    const [supplier, setSupplier] = useState({});
    const [btnAddDisabled, setBtnAddDisabled] = useState(true);
    const [dtSuppliersRowIndex, setDtSuppliersRowIndex] = useState(0);
    const [btnSupplierProcess, setBtnSupplierProcess] = useState(true);
    const [btnSuppliersSyncDisabled, setBtnSuppliersSyncDisabled] = useState(true);
    //#endregion suppliers

    //#region buildings
    const buildingsId = 'buildings';
    const [building, setBuilding] = useState({});
    const [buildings, setBuildings] = useState([]);
    //#endregion buildings

    //#region countries
    const [countries, setCountries] = useState([]);
    //#endregion countries

    //#region others
    const controls = {
        buttons: {
            // save: {
            //     id: 'btnCreate',
            //     className: 'btn btn-outline-warning mx-1',
            // },
            // back: {
            //     id: 'btnBack',
            //     className: '',
            // },
            // close: {
            //     id: 'btnClose',
            //     className: 'close btn-danger fas fa-window-close',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            suppliers: {
                buttons: {
                    create: {
                        className: 'btn btn-outline-success float-right btn-sm mx-1',
                        id: 'btnDtSuppliersCreate',
                    },
                },
                icons: {
                    create: {
                        id: 'iconDtSuppliersCreate',
                        className: globalSettings?.icons?.plusCircle,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtSuppliersId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtSuppliersId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    create: {
                        id: 'spDtSuppliersCreate',
                        className: '',
                    },
                },
            },
        },
        icons: {
            // save: {
            //     id: 'icoSave',
            //     className: globalSettings?.icons?.save,
            // },
            // back: {
            //     id: 'icoBack',
            //     className: globalSettings?.icons?.arrowCircleLeft,
            // },
            // close: {
            //     id: 'icoClose',
            //     className: globalSettings?.icons?.plusCircle,
            // },
        },
        inputs: {
            // user: {
            //     id: 'inputUser',
            //     className: 'form-control bg-transparent',
            // },
            // title: {
            //     id: 'inputTitle',
            //     className: 'form-control bg-transparent',
            // },
            // comment: {
            //     id: 'inputComment',
            //     className: 'form-control',
            // },
            // statusComment: {
            //     id: 'inputStatusComment',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            // save: {
            //     id: 'spSave',
            //     className: '',
            // },
            // back: {
            //     id: 'spBack',
            //     className: '',
            // },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region suppliers (methods)
    const dataTableSuppliersSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTableSuppliersSetAsync';
        let response = responseGet();
        try {
            $(`#${dtSuppliersId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: globalSettings?.labels?.description?.[languageObj?.id], width: '65%', },
                    { title: globalSettings?.labels?.rif?.[languageObj?.id], width: '15%', },
                    //{ title: globalSettings?.labels?.isNational, className: 'text-center', width: '15%', },
                    { title: globalSettings?.labels?.type?.[languageObj?.id], width: '15%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtSuppliersId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const suppliersGetAsync = async ({ e = {}, processType_ = 's', subMethod = '' }) => {
        const currentMethod = 'suppliersGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ buildings: false, suppliers: true, });

            //#region variables
            let dtRows = [];
            let isEditLocal = false;
            let isDeleteLocal = false;
            let buildingLocal = buildingModelGet({});
            let suppliersLocal = [supplierModelGet({})];
            let buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            //#region initialize
            setBtnAddDisabled(true);
            setBtnSupplierProcess(true);
            setBtnSuppliersSyncDisabled(true);

            $(`#${dtSuppliersId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            //#endregion initialize

            //#region suppliers get
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings.find(({ id, }) => id === buildingIdLocal);
                if (!isUndNullEmp({ data: buildingLocal, subMethod: currentMethod, })?.result) {
                    setBuilding(buildingLocal);

                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        }
                    };

                    dataObj = {
                        buildingId: buildingIdLocal,
                        conditionals: [
                            { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${buildingIdLocal}`, },
                        ],
                        ordersBy: [
                            { field: globalSettings?.collections?.properties?.description, value: 'asc' },
                        ],
                        languageId: languageObj?.id,
                        url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlSuppliers}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ buildings: false, suppliers: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    suppliersLocal = response?.result;

                    //#region add suppliers dtTable (suppliers)
                    if (!isUndNullEmp({ data: suppliersLocal, subMethod: currentMethod, })?.result && suppliersLocal?.length > 0) {

                        for (let supplier of suppliersLocal) {
                            response = await supplierProcessButtonsGetAsync({
                                supplier: supplier,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });

                            if (!response?.isSuccess || response.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return;
                            }
                            dtRows?.push(response?.result);
                        }
                    }

                    setBtnSupplierProcess(false);
                    //#region add suppliers dtTable (suppliers)

                    //#region check is enebled btnAdd
                    isEditLocal = processEvaluateGet({
                        object: buildingLocal,
                        property: globalSettings?.labels?.process?.en?.toLowerCase(),
                        process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result;

                    isDeleteLocal = isEditLocal;
                    //#endregion check is enebled btnAdd

                    setBtnSuppliersSyncDisabled(false);
                    setBtnAddDisabled(!(isEditLocal && isDeleteLocal));
                }

                //#region dataTable set / clears set data
                $(`#${dtSuppliersId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
                //#endregion dataTable set / clears set data
            }
            //#endregion suppliers get

            setShowLoading({ buildings: false, suppliers: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, suppliers: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const supplierAddDetailsEditGetAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, process = 0, subMethod = '', }) => {
        const currentMethod = 'supplierAddDetailsEditGetAsync';
        let response = responseGet();
        try {
            //#region variables
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            //#region building validate
            if (isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: globalSettings?.messages?.youMustSelectBuilding?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return
            }
            //#endregion building validate

            if (process === 0) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
            } else if (process === 1 || process === 2) {
                setShowLoading({ buildings: false, suppliers: true, });
            }

            //#region countries get
            response = await countriesGetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                if (process === 0) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                } else if (process === 1 || process === 2) {
                    setShowLoading({ buildings: false, suppliers: false, });
                }
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion get countries

            //#region get supplier
            setProcessType(process);

            //#region process type
            if (process === 0) {
                setSupplier(
                    supplierModelGet({
                        buildingId: buildingIdLocal,
                        countryId: '',
                        userId: auth?.user?.uid,
                    })
                );
            } else {
                //#region data get
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        languageId: languageObj?.id,
                    },
                    url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlSuppliers}/${id}`,
                };

                result = await axios?.get(
                    headerObj?.url,
                    headerObj
                );

                response = result?.data;

                if (!response?.isSuccess || response?.isWarning) {
                    if (process === 0) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    } else if (process === 1 || process === 2) {
                        setShowLoading({ buildings: false, suppliers: false, });
                    }
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                setSupplier(response?.result);
                //#endregion data get
            }
            //#endregion process type

            setDtSuppliersRowIndex(rowIndex);
            //#endregion get supplier

            if (process === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else if (process === 1 || process === 2) {
                setShowLoading({ buildings: false, suppliers: false, });
            }
            setShowModal(true);
        } catch (ex) {
            if (process === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else if (process === 1 || process === 2) {
                setShowLoading({ buildings: false, suppliers: false, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const supplierDeleteAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, subMethod = '' }) => {
        const currentMethod = 'supplierDeleteAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region show message
            let msgTextObj = {
                one: `${globalSettings?.labels?.supplier?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        //#region expenseTemplate delete
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlSuppliers}/${id}`
                        };

                        result = await axios?.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion expenseTemplate delete

                        //#region dtExpenseTemplate update
                        $(`#${dtSuppliersId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);

                        setProcessType(0);
                        //#endregion dtExpenseTemplate update

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message

            //#region old code
            // //#region show message

            // let localMsgText = `${globalSettings?.labels?.supplier?.[languageObj?.id]}: <b>${description}</b><br/>`;
            // localMsgText += `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

            // swalProperties = {
            //     icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
            //     title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
            //     html: localMsgText,
            //     timer: null,
            //     confirmButtonColor: globalSettings?.colors?.warningColorExp,
            //     confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
            //     showCancelButton: true,
            //     cancelButtonColor: globalSettings?.colors?.successColorExp,
            //     cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
            //     timerProgressBar: false,
            //     didOpen: () => {
            //         Swal.hideLoading();
            //     },
            // };

            // const { isConfirmed, } = await Swal.fire(swalProperties);

            // //#endregion show message

            // //#region delete data

            // if (isConfirmed) {
            //     sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

            //     //#region delete supplier

            //     headerObj = {
            //         headers: {
            //             authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //         }
            //     };

            //     //result = await axios.delete(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlSuppliers}/${id}`, headerObj);
            //     result = await axios.delete(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlSuppliers}/${id}`, headerObj);
            //     response = result.data;

            //     if (!response?.isSuccess || response?.isWarning) {
            //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //         return;
            //     }

            //     //#endregion delete supplier

            //     //#region delete supplier (dataTable)

            //     $(`#${dtSuppliersId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);

            //     //#endregion delete supplier (dataTable)

            //     sendMessage(0, globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            // }
            // //#endregion delete data
            //#endregion old code
        } catch (ex) {
            setShowLoading({ buildings: false, suppliers: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const localSupplierDeletePostAsync = async (id, rowIndex) => {
    //     let response = responseGet();
    //     try {
    //         sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         //#region delete supplier

    //         //result = await axios.delete(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlSuppliers}/${id}`);
    //         result = await axios.delete(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlSuppliers}/${id}`);
    //         response = result.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             sendMessage(response.msgType, replaceMessages(3, response.msgText).result, 0, true, false, null, '');
    //             return;
    //         }

    //         //#endregion delete supplier

    //         //#region delete supplier (dataTable)

    //         $(`#${dtSuppliersId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);

    //         //#endregion delete supplier (dataTable)

    //         sendMessage(0, globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: localSupplierDeletePostAsync<br/>${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code

    const supplierBalanceGetAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, subMethod = '' }) => {
        const currentMethod = 'supplierBalanceGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region old code
            //#region Previous data
            // id = processValues.id;
            // description = processValues.description;
            // rowIndex = processValues.dtRowIndex;
            //#endregion Previous data
            //#endregion old code

            //#region show message
            let msgTextObj = {
                one: `${description}</br>`,
                two: `${globalSettings?.messages?.howDoYouWantToViewTheInformation?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.question,
                title: globalSettings?.labels?.supplierBalance?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                confirmButtonColor: globalSettings?.colors?.primaryColorExp,
                confirmButtonText: globalSettings?.labels?.resume?.[languageObj?.id],
                showCancelButton: true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: globalSettings?.labels?.cancel?.[languageObj?.id],
                showDenyButton: true,
                denyButtonText: globalSettings?.labels?.detail?.[languageObj?.id],
                denyButtonColor: globalSettings?.colors?.infoColorExp,
                didOpen: () => {
                    Swal.hideLoading();
                },
            };

            //const { dismiss, isConfirmed, isDenied, } = await Swal.fire(swalProperties);
            const { dismiss, isDenied, } = await Swal.fire(swalProperties);

            if (dismiss === globalSettings?.sweetAlert2?.dismiss?.cancel) {
                return;
            }
            //#endregion show message

            setShowLoading({ buildings: false, suppliers: true, });

            //#region data get
            dataObj = {
                buildingId: $(`#${buildingsId}`)?.val(),
                conditionals: [],
                //isResumen: isConfirmed,
                //isDetail: isDenied,
                isDetail: isDenied,
                method: globalSettings?.app?.backend?.methods?.supplierBalance,
                ordersBy: [],
                processType: globalSettings?.app?.reports.processType.supplierCurrentBalanceGet,
                supplierId: id,
                userId: auth?.user?.uid,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlSuppliers}/`,
            };

            if (!dataObj?.isDetail) {
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    }
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );

                response = result?.data;

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ buildings: false, suppliers: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                //#region resumen set
                //#region old code
                // let debtPercentageTextLocal = `%${globalSettings?.labels?.debt?.[languageObj?.id]}: <b>${separatorsNumbersSet(numberSet(response.result.purchases.resume.periodDebtPergentage, 'd').result).result}</b>`;
                // debtPercentageTextLocal = `${setBadgeStatusGeneric(response.result.purchases.resume.periodDebtIcon, `<i class='${globalSettings?.icons?.certificate}'></i>`)} ` + debtPercentageTextLocal;

                // response.msgText = `${response.result.supplier.description}<br/>`;
                // response.msgText += `${debtPercentageTextLocal}<br/>`;
                // response.msgText += `<br/>`;
                // response.msgText += `${globalSettings?.labels?.total?.[languageObj?.id]}: <b>${separatorsNumbersSet(numberSet(response.result.purchases.resume.periodTotal, 'd').result).result}</b><br/>`;
                // response.msgText += `${globalSettings?.labels?.balance?.[languageObj?.id]}: <b>${separatorsNumbersSet(numberSet(response.result.purchases.resume.periodBalance, 'd').result).result}</b><br/>`;
                //#endregion old code

                dataObj = {
                    periodDebtPergentage: separatorsNumbersSet({
                        number: numberSet({
                            number: response?.result?.purchases?.resume?.periodDebtPergentage || 0.00,
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    }).result,
                    periodTotal: separatorsNumbersSet({
                        number: numberSet({
                            number: response?.result?.purchases?.resume?.periodTotal || 0.00,
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    periodBalance: separatorsNumbersSet({
                        number: numberSet({
                            number: response?.result?.purchases?.resume?.periodBalance || 0.00,
                            type: 'd',
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,
                    badget: setBadgeStatusGeneric({
                        //type: response?.result?.purchases?.resume?.periodDebtIcon || 5,
                        type: response?.result?.purchases?.resume?.periodDebtIcon,
                        value: `<i class='${globalSettings?.icons?.certificate}'></i>`,
                        subMethod: currentMethod,
                    }),
                    msgText: '',
                };

                dataObj.msgText = `%${globalSettings?.labels?.debt?.[languageObj?.id]}: <b>${dataObj?.periodDebtPergentage}</b>`;
                dataObj.msgText = `${dataObj?.badget} ` + dataObj?.msgText;

                response.msgText = `${response?.result?.supplier?.description}<br/>`;
                response.msgText += `${dataObj?.msgText}<br/>`;
                response.msgText += `<br/>`;
                response.msgText += `${globalSettings?.labels?.total?.[languageObj?.id]}: <b>${dataObj?.periodTotal}</b><br/>`;
                response.msgText += `${globalSettings?.labels?.balance?.[languageObj?.id]}: <b>${dataObj?.periodBalance}</b><br/>`;
                //#endregion resumen set

                setShowLoading({ buildings: false, suppliers: false, });

                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    msgTitle: globalSettings?.labels?.supplierBalance?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
            } else {
                window?.open(`${globalSettings?.app?.backend?.urlSupplierCurrentBalance}/${id}`, '_blank');
                setShowLoading({ buildings: false, suppliers: false, });
            }
            //#endregion data get
        } catch (ex) {
            setShowLoading({ buildings: false, suppliers: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion suppliers (methods)

    //#region countries (methods)
    const countriesGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'countriesGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let countriesLocal = [countryModelGet({})];
            //#endregion variables

            //#region initialize
            setCountries([]);
            //#endregion initialize

            //#region countries get
            response = await validationCountryGetAsync({
                buildingId: building?.id,
                limit: 0,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            countriesLocal = response?.result;
            setCountries(countriesLocal);
            //#endregion countries get
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion countries (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ buildings: true, suppliers: true, });

            //#region inicialize
            //#endregion inicialize

            //#region dataTable set
            response = await dataTablesSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, suppliers: false, });
                return;
            }
            //#endregion dataTable set

            //#region buildings get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: globalSettings?.app?.backend?.urlSuppliers,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, suppliers: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (!isUndefined(response.result) && !isNull(response.result) && !isEmpty(response.result) &&
                !isUndefined(response.result.buildings) && !isNull(response.result.buildings) && response.result.buildings.length > 0) {
                setBuildings(response.result.buildings);
            }
            //#endregion buildings get

            setShowLoading({ buildings: false, suppliers: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, suppliers: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            response = await dataTableSuppliersSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = await queryCodeSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region suppliers
            $(`#${dtSuppliersId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtSuppliersId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            supplierAddDetailsEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, process: 2, subMethod: currentMethod, });
                            break;
                        case 'edit':
                            supplierAddDetailsEditGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, process: 1, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            supplierDeleteAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        case 'balance':
                            //#region old code
                            // setProcessValues({ ...processValues, e, id: id, description: description, dtRowIndex: dtRowIndex, });
                            // $(`#${btnSupplierBalanceId}`)?.trigger('click');
                            //#endregion old code
                            supplierBalanceGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion suppliers
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    //#region old code
    // const localDataTableClears = (dtSupliersClear = false) => {
    //     let response = responseGet();
    //     try {
    //         if (dtSupliersClear) {
    //             $(`#${dtSuppliersId}`)?.DataTable()?.rows()?.clear()?.draw(true);
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localDataTableClears<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.suppliers?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.suppliers?.buttons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.suppliers?.spinners?.create?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.suppliers?.icons?.create?.id}`)?.addClass(controls?.dataTables?.suppliers?.icons?.create?.className);
                    $(`#${controls?.dataTables?.suppliers?.buttons?.create?.id}`)?.addClass(controls?.dataTables?.suppliers?.buttons?.create?.className);
                    $(`#${controls?.dataTables?.suppliers?.spinners?.create?.id}`)?.addClass(controls?.dataTables?.suppliers?.spinners?.create?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.suppliers?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.suppliers?.spinners?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.suppliers?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.suppliers?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.suppliers?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='expenses' process='suppliers' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.suppliers?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.suppliers?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {/*buildings*/}
                        <BuildingHeader buildingsId={buildingsId}
                            building={building}
                            buildings={buildings}
                            btnSyncDisabled={btnSuppliersSyncDisabled}
                            methodGetAsync={suppliersGetAsync}
                            processType={0}
                            headerSectionValues={{}}
                            showLoading={showLoading?.buildings}
                            languageObj={languageObj} />

                        {/*suppliers*/}
                        <div className='row'>
                            <div className='col-12'>
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.suppliers}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={globalSettings?.labels?.suppliers?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.suppliersLogo}></img> - {globalSettings?.labels?.suppliers?.[languageObj?.id]}
                                        </h6>
                                        {/* <div className='card-tools'> */}
                                        {/* <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button> */}
                                        {/* </div> */}
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            {/*{!showLoading ?*/}
                                            <div className='col-md-12'>
                                                {/* {showData ? */}
                                                {/* <div> */}
                                                <button id={controls?.dataTables?.suppliers?.buttons?.create?.id}
                                                    className={controls?.dataTables?.suppliers?.buttons?.create?.className}
                                                    //className='btn btn-outline-success float-right btn-sm mx-1'
                                                    tooltip='tooltip'
                                                    title={globalSettings?.labels?.create?.[languageObj?.id]}
                                                    disabled={btnSupplierProcess || btnAddDisabled}
                                                    onClick={(e) => supplierAddDetailsEditGetAsync({ e: e, id: '', description: '', rowIndex: 0, process: 0, subMethod: 'btn - supplierAdd', })}>
                                                    <i id={controls?.dataTables?.suppliers?.icons?.create?.id} className={controls?.dataTables?.suppliers?.icons?.create?.className} /> <span id={controls?.dataTables?.suppliers?.spinners?.create?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                {/* <button id={btnSupplierBalanceId}
                                                    className='btn btn-outline-info float-right btn-sm'
                                                    disabled={btnSupplierProcess}
                                                    hidden
                                                    onClick={(e) => supplierBalanceGetAsync(e, '', '', 0)}>
                                                    <i className={globalSettings?.icons?.invoiceDollar}></i>
                                                </button> */}
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtSuppliersId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                {/* </div> */}
                                                {/* : */}
                                                {/* <div></div> */}
                                                {/* } */}
                                            </div>
                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={globalSettings?.colors?.infoColorExp}
                                                    msgText={globalSettings?.messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/*}*/}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </section>

            </div>

            {showModal ?
                <SupplierAddEditDetails $={$}
                    auth={auth}
                    userRole={userRole}
                    supplier={supplier}
                    setSupplier={setSupplier}
                    dtSuppliersId={dtSuppliersId}
                    dtSuppliersRowIndex={dtSuppliersRowIndex}
                    countries={countries}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    processType={processType} />
                :
                <></>
            }
        </div>
    )
}